import { passCodes } from '../passCodes';
import audio from '../../../../assets/audio/kids-tracks/Text8.mp3';
import benchHint from '../../../../assets/images/games/zdar-kids-game/hints/9.webp';

export const step9bench = {
    id: 9,
    title: 'U lavičky',
    taskText: `
        <p>
            Přejeme hezký den, jste paní hraběnka? 
            Tak prý jsme to měli poznat a pokud máme kapku dobrého vychování, bylo by příhodné se i uklonit. 
            Tak se to prý ve dvoře dělávalo. Sice nevím co myslí tím dvorem, ale tak ukloníš se se mnou? 
        </p>
        <p>
            Víte, potkali jsme před chvílí mušketýra a ten nám řekl, že byste nám mohla pomoct vyřešit naši záhadu. 
            Proč se říká Zelené hoře zelená? 
        </p>
        <p> 
            Tak prý na zámku, u kterého jsme naši cestu započali, žije už 100 let, ale nikdy nepřemýšlela o tom, 
            proč se to tu jmenuje Zelená hora. Myslí si ale, že by se měla jmenovat spíše růžová (stejně jako její dům a její komnaty).
        </p>
        <p>
            Hraběnka říká, abychom ji už nechali být, že si chce dál užívat klid sama. Hmm, je trochu namyšlená, 
            ale pokud se nám podaří splnit její úkol, tak nám prý poradí kudy dál.
        </p>
    `,
    cipher: {
        text: `
            Jaké písmenko najdete na lavičce?
        `,
        label: 'Úkol',
    },
    audio: audio,
    codeInputText: ' ',
    codeInputPassCodeRegexp: passCodes[1],
    additionalInfo: 'Odpovědí je jedno písmeno',
    points: true,
    hints: [
        {
            text: 'Jde o písmeno e',
            image: benchHint,
        },
    ],
};
